<mat-radio-group class="table-check"
                 [(ngModel)]="valore"
                 [disabled]="block ? block : false"
                 (change)="valueChange($event)">
    <mat-radio-button *ngFor="let item of list" [value]="item">{{item}}</mat-radio-button>
</mat-radio-group>
